module.exports = __webpack_public_path__ + "img/Michael.e790f35a.jpg";